if (!customElements.get('cart-item')) {
  customElements.define(
    'cart-item',
    class CartItem extends window.BAO.CustomElement {
      _loading = false
      sections = window.BAO.utils.sectionRenderer.cartSections

      setupListeners () {
        super.setupListeners()

        this.removeLineItem = this.removeLineItem.bind(this)
        this.updateQuantity = this.updateQuantity.bind(this)

        if (this.els?.remove?.exists) {
          this.listeners.add(
            this.els.remove.element,
            'click',
            this.removeLineItem,
          )
        }

        if (this.els?.quantity?.exists) {
          this.listeners.add(
            this.els.quantity.element,
            'change',
            this.updateQuantity,
          )
        }
      }

      async removeLineItem (e) {
        const item = e.target.closest('.crt-Products_Item')

        const linkedItem = window.BAO.utils
          .getElements('.crt-Products_Item')
          .find(cartItem => {
            return (
              cartItem.dataset.childId === item.dataset.parentId &&
              cartItem.dataset.childId !== undefined &&
              item.dataset.parentId !== undefined
            )
          })

        const state = await window.BAO.Cart.removeItem(
          this.line,
          this.sections.map(s => s.section),
        )

        if (linkedItem) {
          const state = await window.BAO.Cart.removeItem(
            linkedItem.getAttribute('index'),
            this.sections.map(s => s.section),
          )
          if ('sections' in state) this.renderSections(state.sections)
        } else {
          if ('sections' in state) this.renderSections(state.sections)
        }
        window.BAO.dispatchEvent(window.BAO.EVENTS.PUSH_CART.AFTER_REMOVE)
      }

      async updateQuantity (e) {
        const item = e.target.closest('.crt-Products_Item')
        const linkedItem = window.BAO.utils
          .getElements('.crt-Products_Item')
          .find(cartItem => {
            return (
              cartItem.dataset.childId === item.dataset.parentId &&
              cartItem.dataset.childId !== undefined &&
              item.dataset.parentId !== undefined
            )
          })

        const state = await window.BAO.Cart.updateQuantity(
          this.line,
          parseInt(e.target.value, 10),
          this.sections.map(s => s.section),
        )

        if (linkedItem) {
          const state = await window.BAO.Cart.updateQuantity(
            linkedItem.getAttribute('index'),
            parseInt(e.target.value, 10),
            this.sections.map(s => s.section),
          )
          if ('sections' in state) this.renderSections(state.sections)
        } else {
          if ('sections' in state) this.renderSections(state.sections)
        }
        window.BAO.dispatchEvent(
          window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
        )
      }

      get loading () {
        return this._loading
      }

      set loading (val) {
        this._loading = val
      }

      get line () {
        return parseInt(this.getAttribute('index'), 10)
      }
    },
  )
}
